import Proxy from "./Proxy"

class CourseTypeProxy extends Proxy {
  constructor(parameters = {}) {
    super("course-types", parameters)
  }
}

export default CourseTypeProxy
